import { IHeaderInformation } from "../../interfaces/ux/header-information.interface";
import { Utilities, Dictionary } from "../../utils/utilities";
import { useSelector } from "react-redux";
import { BasePresenter } from "../base/base.presenter";

export class HeaderInformationPresenter extends BasePresenter<IHeaderInformation> {
    private currentLabel: Dictionary<string,string>;
    private _props: IHeaderInformation

    public constructor(props: IHeaderInformation){
        super(props);  
        this._props = props;   
        this.currentLabel = useSelector(this.context.sessionStore.selectLabels) as Dictionary<string,string>;
    }

    public getFieldName(fieldName: string){
        if(!Utilities.isNullEmptyObject(this.currentLabel)){
            const label = this.currentLabel.get(fieldName);
            return label;
        }
    }
}
